export interface AssociationProperties {
  portalSeccioninmobiliariacamaradecomercio: boolean
}

export const REGISTERED_ASSOCIATIONS_DICTIONARY_BY = {
  25: 'portalSeccioninmobiliariacamaradecomercio'
}

export const idToAssociationMap: {
  [key: string]: keyof AssociationProperties
} = {
  25: 'portalSeccioninmobiliariacamaradecomercio'
}

export const MACROBOLSA_ASSOCIATION_ID = '22,23,25,74'

interface IAssociation {
  value: string
  label: string
}

export const MACROBOLSA_ASSOCIATION_FILTER: IAssociation[] = [
  {
    label: 'Movimiento Inmobiliario de Occidente AC',
    value: '22'
  },
  {
    label: 'PAIS',
    value: '23'
  },
  {
    label: 'Sección Inmobiliaria Cámara de Comercio',
    value: '25'
  },
  {
    label: 'AMPI Guadalajara',
    value: '74'
  }
]
